// Simple FAQ Show More functionality
document.addEventListener('DOMContentLoaded', function () {
  // Handle show more button clicks
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-show-more-btn]')) {
      const button = e.target;
      const faqList = button.closest('.faq-section__list');
      const hiddenItems = faqList.querySelectorAll('.faq-section__item--hidden');

      // Show all hidden items
      hiddenItems.forEach(function (item) {
        item.classList.remove('faq-section__item--hidden');
      });

      // Hide the show more button
      button.closest('.faq-section__show-more').style.display = 'none';
    }
  });
});
